<template>
  <div class="labeling_group">
      <div class="label_link" :class="{ lldp: (type === 'LLDP')}">
          <div class="link_icon"></div>
          <span class="text" v-if="type === 'LLDP'">{{$t('mirroring.transReceive')}}</span>
          <span class="text" v-else>{{$t('linkUp')}}</span>
      </div>
      <div class="label_nolink" :class="{ lldp: (type === 'LLDP')}">
          <div class="nolink_icon">
          </div>
          <span class="text" v-if="type === 'LLDP'">{{$t('mirroring.transOnly')}}</span>
          <span class="text" v-else>{{$t('linkDown')}}</span>
      </div>
      <div v-if="type === 'Mirroring'" :class="{ mirroring: (type === 'Mirroring')}">
        <div class="label_link">
          <div class="link_icon"></div>
          <span class="text">{{$t('mirroring.sourceNoColon')}}</span>
        </div>
        <div class="label_nolink">
          <div class="nolink_icon"></div>
          <span class="text">{{$t('mirroring.destinationNoColon')}}</span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'labeling',
  props: {
    type: String
  }
}
</script>

<style lang="scss" scoped>
.labeling_group {
  position: relative;
  margin: auto;
  user-select: none;
  .label_link {
      display: flex;
      width: max-content;
      .link_icon {
        margin: 6px 0;
        background: #7ED321;
        width: 10px;
        height: 10px;
      }
      .text {
          margin-left: 4px;
          font-size: 12px;
          color: #2F2F2F;
          line-height: 22px;
      }
      &.lldp {
        .link_icon {
          background: #E38DF5;
        }
      }
  }
  .label_nolink {
      display: flex;
      width: max-content;
      .nolink_icon {
          margin: 6px 0;
          background: #DBDDDD;
          width: 10px;
          height: 10px;
      }
      .text {
          margin-left: 4px;
          font-size: 12px;
          color: #2F2F2F;
          line-height: 22px;
      }
      &.lldp {
        .nolink_icon {
          background: #2BBAF0;
        }
      }
  }
  .mirroring {
    .label_link {
      .link_icon {
        background: #4AD2E2;
      }
    }
    .label_nolink {
      .nolink_icon {
        background: #BD10E0;
      }
    }
  }
  .label_receive {
    display: flex;
    width: max-content;
    .receive_icon {
          margin: 6px 0;
          background: #7ED321;
          width: 10px;
          height: 10px;
      }
      .text {
          margin-left: 4px;
          font-size: 12px;
          color: #2F2F2F;
          line-height: 22px;
      }
  }
  .label_disable {
    display: flex;
    width: max-content;
    .disable_icon {
          margin: 6px 0;
          background: #ffffff;
          border: 0.25px solid #A8A8A8;
          width: 10px;
          height: 10px;
      }
      .text {
          margin-left: 4px;
          font-size: 12px;
          color: #2F2F2F;
          line-height: 22px;
      }
  }
  .label_loop {
    display: flex;
    width: max-content;
    .loop_icon {
          margin: 6px 0;
          background: #F54848;
          width: 10px;
          height: 10px;
      }
      .text {
          margin-left: 4px;
          font-size: 12px;
          color: #2F2F2F;
          line-height: 22px;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/Labeling.vue